import React from "react";

const InFlight = () => {
  return <div>InFlight Page</div>;
};

export { InFlight as default };
